import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { StaffModel } from 'src/app/models/staff.model';

@Component({
  selector: 'tx-section-signatures-dropdown',
  templateUrl: './section-signatures-dropdown.component.html',
  styleUrls: ['./section-signatures-dropdown.component.scss'],
})
export class SectionSignaturesDropdownComponent {
  @Input() showAttorneys = true;
  @Input() showStaff = true;
  @Input() attorneys$!: Observable<StaffModel[]>;
  @Input() staff$!: Observable<StaffModel[]>;
  @Output() onItemClick = new EventEmitter<string>();

  itemClick(id: string) {
    this.onItemClick.emit(id);
  }
}
